<template>
  <div style="text-align:center;" id="main">
    <button class="fullBtn" @click="getUser">
      <inline-svg
        class="googleIcon"
        :src="require('../../assets/svg/googleicon.svg').default"
      ></inline-svg>
      {{ $t("user.loginButton.button") }}
    </button>
  </div>
</template>

<script>
import { userService } from "../../services/userService";
import { Capacitor } from "@capacitor/core";
import { GoogleAuth } from "@codetrix-studio/capacitor-google-auth";
import "../Shared/style.scss";

export default {
  name: "LoginButton",
  data() {
    return {
      userData: null,
      platform: null
    };
  },
  created() {
    this.platform = Capacitor.getPlatform();
  },
  mounted() {},
  methods: {
    async getUser() {
      if (this.platform == "web") {
        // this.userData = await userService.googleLogin();
      } else {
        const response = await GoogleAuth.signIn();
        console.log(response);
        // const token = await userService.getToken(
        //   response.authentication.accessToken
        // );
      }

      console.log(this.userData);
    },

    async handleCredentialResponse(response) {
      console.log(response);
      this.client.requestCode();
    },

    navigate(path) {
      this.$router.push(`/${path}`);
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
  watch: {
    user() {
      if (this.user) {
        this.navigate("chapter/1");
      }
    }
  },
  components: {}
};
</script>

<style scoped>
.googleIcon {
  width: 25px;
}
</style>



// WEBPACK FOOTER //
// LoginButton.vue?0eb15b0b